// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

// https://1mojio.atlassian.net/wiki/spaces/API/pages/1381531653/Share+Location+V1


import { IEnvironment } from './ienvironment';

export const environment: IEnvironment = {
  production: false,
  apiUrl: 'https://force-us-phoenix-staging-api.moj.io',
  clientId: 'd447f0aa-ed95-4129-81d0-ed9b87485d77',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
